export default {
	list: 'InputControl',
	query: {
		filter: "substringof('EUM',Scope)",
		limit: 5000
	},
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		Field: {
			class: "value",
			dataName: 'Field',
			type: 'string',
			title: 'Field',
			width: 100,
			hidden: false,
			readOnly: false
		},
		Option: {
			class: "value",
			dataName: 'Option',
			type: 'string',
			title: 'Option',
			width: 100,
			hidden: false,
			readOnly: false
		},
		ReadOnly:{
			class: "value",
			dataName: 'ReadOnly',
			type: 'string',
			title: 'ReadOnly',
			width: 100,
			hidden: true,
			menu:false,
			readOnly: false
		}
	}
}